import BulkAddModal from "app/pages/sales-intelligence/common-components/modals/BulkAddModal/BulkAddModal";
import type { AppsIdentifiers } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/types";
import {
    getBulkAddTextConfig,
    parseInputValue,
} from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/utils";

import { StyledBulkAddContainer } from "./styles";

type AppIdentifierBulkAddProps = {
    onUpdate: (value: string[]) => void;
    appIdentifierType: AppsIdentifiers;
};

const AppIdentifierBulkAdd: React.FC<AppIdentifierBulkAddProps> = ({ onUpdate, appIdentifierType }) => {
    const { header, text, counterText, placeholder, buttonText } = getBulkAddTextConfig(appIdentifierType);

    return (
        <StyledBulkAddContainer>
            <BulkAddModal
                onAddValues={onUpdate}
                parseInputValue={parseInputValue}
                header={header}
                text={text}
                counterText={counterText}
                placeholder={placeholder}
                buttonText={buttonText}
            />
        </StyledBulkAddContainer>
    );
};

export default AppIdentifierBulkAdd;
